var ULRpcMessage = function ULRpcMessage(procedureName, nonce, appId) {
    this.version = '__npmVersion__';
    this.procedureName = procedureName;
    this.appId = appId;
    this.nonce = nonce;
};

function _inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of$2(subClass, superClass);
}
function _set_prototype_of$2(o, p) {
    _set_prototype_of$2 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of$2(o, p);
}
var ULRpcRequestMessage = /*#__PURE__*/ function(ULRpcMessage) {
    _inherits$2(ULRpcRequestMessage, ULRpcMessage);
    function ULRpcRequestMessage(procedureName, args, nonce, appId) {
        var _this;
        _this = ULRpcMessage.call(this, procedureName, nonce, appId) || this, _this.type = 'request';
        _this.args = args;
        return _this;
    }
    return ULRpcRequestMessage;
}(ULRpcMessage);

function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of$1(subClass, superClass);
}
function _set_prototype_of$1(o, p) {
    _set_prototype_of$1 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of$1(o, p);
}
var ULRpcResponseMessage = /*#__PURE__*/ function(ULRpcMessage) {
    _inherits$1(ULRpcResponseMessage, ULRpcMessage);
    function ULRpcResponseMessage(procedureName, data, nonce, appId) {
        var _this;
        _this = ULRpcMessage.call(this, procedureName, nonce, appId) || this, _this.type = 'response';
        _this.data = data;
        return _this;
    }
    return ULRpcResponseMessage;
}(ULRpcMessage);

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
var ULRpcResponseErrorMessage = /*#__PURE__*/ function(ULRpcMessage) {
    _inherits(ULRpcResponseErrorMessage, ULRpcMessage);
    function ULRpcResponseErrorMessage(procedureName, error, nonce, appId) {
        var _this;
        _this = ULRpcMessage.call(this, procedureName, nonce, appId) || this, _this.type = 'errorResponse';
        _this.error = error;
        return _this;
    }
    return ULRpcResponseErrorMessage;
}(ULRpcMessage);

export { ULRpcMessage, ULRpcRequestMessage, ULRpcResponseErrorMessage, ULRpcResponseMessage };
